import { router } from '@inertiajs/vue3';

export function useServicosNavigation() {
    const getServicosRoute = (agrupamento, path = null, pesquisa = null, matricula = null) => route('servicos', { agrupamento, path, pesquisa, matricula });
    const getFormularioRoute = (formularioId) => route('formulario', { formularioId });

    const goToServicos = (agrupamento, path = null, pesquisa = null, matricula = null) => router.visit(getServicosRoute(agrupamento, path, pesquisa, matricula));
    const goToFormulario = (formularioId) => router.visit(getFormularioRoute(formularioId));

    return { getServicosRoute, getFormularioRoute, goToServicos, goToFormulario };
}
